import { useState, useEffect } from "react";
import styles from "../../styles/chatStyles";
import GroupAvatar from "../ui/GroupAvatar";

import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";


export default function ChatItem({
  chat,
  onClick,
  mode,
  isActive,
  selectedChat,
}) {
  const [hovered, setHovered] = useState(false);
  const [membersData, setMembersData] = useState([]);
  const [groupData, setGroupData] = useState(null);

  const isGroup = chat?.type === "group" || chat?.isGroup;
  const currentUser = localStorage.getItem("user");

  const chatId = chat
  ? isGroup
    ? chat.id
    : chat?.user?.username
    ? [currentUser, chat.user.username].sort().join("_")
    : null
  : null;

  console.log("chatId:", chatId);
  

  // ===============================
  // 👥 загрузка участников (БЕЗ realtime)
  // ===============================
  // ===============================
// 👥 загрузка участников (через groupData)
// ===============================

useEffect(() => {
  if (!isGroup || !chatId) return;

  const load = async () => {
    try {
      const snap = await getDoc(doc(db, "chats", chatId));
      if (snap.exists()) {
        setGroupData(snap.data());
      }
    } catch {}
  };

  load();
}, [chatId, isGroup]);

useEffect(() => {
  if (!isGroup || !groupData?.members?.length) return;

  let mounted = true;

  const load = async () => {
    const result = [];

    for (let username of groupData.members) {
      try {
        const snap = await getDoc(doc(db, "users", username));

        if (snap.exists()) {
          result.push({
            username,
            ...snap.data(),
          });
        } else {
          result.push({ username });
        }
      } catch {
        result.push({ username });
      }
    }

    if (mounted) setMembersData(result);
  };

  load();

  return () => (mounted = false);
}, [groupData, isGroup]);

  // ===============================
  // 🧠 имя группы
  // ===============================
  const getGroupName = () => {
  // ✅ если есть имя группы
  if (groupData?.name || chat?.name) {
    return groupData?.name || chat?.name;
  }

  // ✅ берём участников ИЗ groupData (главное отличие!)
  const sourceMembers =
    groupData?.members || chat?.members || [];

  // 🔥 если вообще нет участников — значит реально fallback
  if (!sourceMembers.length) return "Группа";

  // сначала пробуем users
  if (membersData.length) {
    const names = membersData
      .filter((u) => u.username !== currentUser)
      .map((u) => u.name || u.username)
      .slice(0, 3);

    if (names.length) return names.join(", ");
  }

  // fallback по username
  const fallback = sourceMembers
    .filter((u) => u !== currentUser)
    .slice(0, 3);

  return fallback.length ? fallback.join(", ") : "Группа";
};


  const name = isGroup
    ? getGroupName()
    : chat?.user?.name || chat?.user?.username;

  // ===============================
  // 🖼️ аватар
  // ===============================
  
const lastSeen = chat?.user?.lastSeen || 0;

const online =
  !isGroup &&
  chat?.user?.online &&
  Date.now() - lastSeen < 15000; // 15 секунд

  // ===============================
  // 🔥 unread / typing
  // ===============================
  const unreadCount = chat?.unread?.[currentUser] || 0;

  console.log("UNREAD DEBUG:", {
  chatId: chat.id,
  unread: chat.unread,
  currentUser,
  count: chat?.unread?.[currentUser]
});
  const hasUnread = unreadCount > 0;

  const typing = chat?.typing;

  const isDefaultGroupAvatar = isGroup && !chat?.avatar;

  const inactiveStyle =
    selectedChat && !isActive
      ? { filter: "grayscale(100%) opacity(0.5)" }
      : {};

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
  ...styles.chatItem,

  display: "flex",
  alignItems: "center",

  justifyContent:
    mode === "compact" ? "center" : "flex-start",

  padding:
    mode === "compact" ? "10px 0" : "8px 10px",

  width: "100%",
  boxSizing: "border-box",

  overflow: "hidden", // 💣 фикс пропадания

            
       background: hasUnread
            ? "rgba(255,255,255,0.12)"
            : hovered
            ? "rgba(255,255,255,0.05)"
            : isActive
            ? "rgba(255,255,255,0.08)"
            : "transparent",

            backdropFilter: hasUnread
            ? "blur(18px)"
            : hovered
            ? "blur(10px)"
            : "none",

            boxShadow: hasUnread
            ? "0 4px 20px rgba(255,255,255,0.12)"
            : hovered
            ? "0 0 10px rgba(255,255,255,0.05)"
            : "none",

            border: hasUnread
            ? "1px solid rgba(255,255,255,0.18)"
            : "1px solid transparent",

        transform:
  mode === "compact"
    ? "none"
    : hovered
    ? "translateX(2px)"
    : "translateX(0)",
        transition: "all 0.2s ease",
        borderRadius: 12,
      }}
    >
<div
  style={{
    position: "relative",

    width: 42,
    height: 42,
    minWidth: 42,

    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    

    margin: mode === "compact" ? "0 auto" : 0, // 💣 ВАЖНО

    filter:
        selectedChat && !isActive
    ? isDefaultGroupAvatar
      ? "opacity(0.35) blur(1px) contrast(0.8)"
      : "grayscale(100%) opacity(0.5)"
      
    : "none",

    transition: "0.2s"
  }}
>
  {isGroup ? (
    <GroupAvatar
      src={chat?.avatar}
      name={name}
      size={42}
    />
  ) : (
    <img
  src={chat?.user?.avatar || "/group-avatar.svg"}
  alt=""
  style={{
    width: 42,
    height: 42,
    borderRadius: "50%",
    objectFit: "cover",
  }}
/>
  )}

  {/* 🟢 онлайн */}
  {!isGroup && online && (
    <div
      style={{
        position: "absolute",
        bottom: 2,
        right: 2,
        width: 12,
        height: 12,
        borderRadius: "50%",
        background: "#4cff4c",
        boxShadow: "0 0 6px #4cff4c",
        border: "2px solid #0b0b0b",
      }}
    />
  )}

  {/* 👥 бейдж */}
  {isGroup && (
    <div
      style={{
        position: "absolute",
        bottom: -2,
        right: -2,
        fontSize: 10,
        background: "#111",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: 6,
        padding: "1px 4px",
        opacity: 0.8,
      }}
    >
      👥
    </div>
  )}
</div>

      {/* 🔥 ТЕКСТ */}
      {mode !== "compact" && (
        <div
  style={{
    marginLeft: mode === "compact" ? 0 : 10,
    minWidth: 0,
    flex: 1
  }}
>
          <div style={{ fontWeight: hasUnread ? 600 : isActive ? 600 : 400 }}>
            {name}
          </div>

          <div style={{ fontSize: 12 }}>
  {typing && typing.user !== currentUser ? (
    <span style={{ color: "#b3b3b3" }}>
      {typing.user}{" "}
      {typing.type === "text" && "печатает..."}
      {typing.type === "deleting" && "удаляет..."}
      {typing.type === "photo" && "отправляет фото..."}
      {typing.type === "voice" && "записывает голосовое..."}
    </span>
  ) : (
    <span
  style={{
    opacity: hasUnread ? 1 : 0.6,
    fontWeight: hasUnread ? 500 : 400,

    display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
  }}
>
  {chat?.lastMessage}
</span>
  )}
</div>
        </div>
      )}

      {/* 🔥 UNREAD */}
      {hasUnread && mode !== "compact" && (
  <div
    style={{
      marginLeft: "auto",
      background: "#fff",
      color: "#000",
      fontSize: 11,
      padding: "2px 6px",
      borderRadius: 10,
      minWidth: 18,
      textAlign: "center",
    }}
  >
    {unreadCount > 99 ? "99+" : unreadCount}
  </div>
)}
    </div>
  );
}